/**
 * @file  helpterms/content.ts
 * @description  handles the html content to interface mapping
 *
 * @author dlima (dlima-electron)
 *
 */
import React from 'react';

const Content = React.lazy(
  () =>
    import('../../content/help-terms')
);

export const ContentLoader = Content;
